import React, { FC, ReactNode } from 'react'
import { CardHeader, CardTitle, IndicatorCardContainer } from './styles'

interface IndicatorCardProps {
  title: string
  /** conteúdo opcional à direita do título (ex.: toggle) */
  action?: ReactNode
  children: ReactNode
}

/** Card branco padrão da dashboard para os novos indicadores analíticos. */
const IndicatorCard: FC<IndicatorCardProps> = ({ title, action, children }) => {
  return (
    <IndicatorCardContainer>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {action}
      </CardHeader>
      {children}
    </IndicatorCardContainer>
  )
}

export default IndicatorCard
